__turbopack_context__.v({
  "actionBtn": "ObjectiveSelector-module__O1cBaW__actionBtn",
  "container": "ObjectiveSelector-module__O1cBaW__container",
  "description": "ObjectiveSelector-module__O1cBaW__description",
  "label": "ObjectiveSelector-module__O1cBaW__label",
  "menuAction": "ObjectiveSelector-module__O1cBaW__menuAction",
  "option": "ObjectiveSelector-module__O1cBaW__option",
  "optionActive": "ObjectiveSelector-module__O1cBaW__optionActive",
  "optionLabel": "ObjectiveSelector-module__O1cBaW__optionLabel",
  "pill": "ObjectiveSelector-module__O1cBaW__pill",
  "pillArrow": "ObjectiveSelector-module__O1cBaW__pillArrow",
  "pillLabel": "ObjectiveSelector-module__O1cBaW__pillLabel",
  "pillWrapper": "ObjectiveSelector-module__O1cBaW__pillWrapper",
  "popover": "ObjectiveSelector-module__O1cBaW__popover",
  "row": "ObjectiveSelector-module__O1cBaW__row",
});
